import * as React from 'react';
import { useForm } from 'react-hook-form';

import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';
import AccessAccountDetails from 'src/models/AccessAccountDetails';

interface IAddAccessAccountDialogProps {
    defaultUserName: string;
    tsdNumber: number;
    handleCreateAccessAccount: (accountDetails: AccessAccountDetails) => void;
    hideDialog: () => void;
}

const AddAccessAccountDialog = (props: IAddAccessAccountDialogProps) => {
    const { register, errors, handleSubmit } = useForm();
    const onSubmit = (accountDetails: AccessAccountDetails) => {
        accountDetails.employeeType = Number(accountDetails.employeeType);
        props.handleCreateAccessAccount({
            ...accountDetails,
            employeeNumber: props.tsdNumber
        });
    };

    return (
        <Dialog
            dialogName={DialogList.ADD_ACCESS_ACCOUNT}
            title="Add Access Account"
        >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <RHFInputBox
                            register={register}
                            errors={errors}
                            defaultVal={props.defaultUserName}
                            type="text"
                            name="userName"
                            label="UserName"
                            labelOnLeft={true}
                            rules={{
                                required: 'User Name is required'
                            }}
                            style={{width: '100%'}}
                            bodyStyle={{width: '50%'}}
                        />
                        <RHFSelect
                            register={register}
                            errors={errors}
                            name="employeeType"
                            label="Type"
                            labelOnLeft={true}
                            options={[
                                { value: 1, label: 'Employee' },
                                { value: 2, label: 'Contractor' },
                                { value: 3, label: 'SubContractor' }
                            ]}
                            style={{width: '100%'}}
                            bodyStyle={{width: '50%'}}
                            labelStyle={{marginRight: '4rem'}}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            type="submit"
                            text="Add Account"
                        />

                        <Button
                            type="button"
                            text="Cancel"
                            style={{ marginLeft: '1rem' }}
                            onClick={props.hideDialog}
                        />
                    </div>
                </form>
        </Dialog>
    );
};

export default AddAccessAccountDialog;


// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/AddAccessAccountDialog.tsx